import { FieldError, Label } from 'react-aria-components';
import { RadioButton } from './RadioButton';
import * as Styled from './RadioButtonGroup.styled';
import type { RadioButtonData, RadioButtonGroupProps } from './types';

const normalizeValue = (value?: string | null) => {
  if (typeof value === 'string') {
    return { value: value === '' ? null : value };
  }

  return {};
};

export const RadioButtonGroup = ({
  className,
  error,
  fields,
  hasDiscreteFields = false,
  legend,
  name,
  value,
  ...deferred
}: RadioButtonGroupProps) =>
  fields ? (
    <Styled.Fieldset
      $hasDiscreteFields={hasDiscreteFields}
      className={className}
      data-validation-key={name}
      isInvalid={Boolean(error)}
      {...normalizeValue(value)}
      {...deferred}
    >
      {legend ? <Label>{legend}</Label> : null}
      <FieldError>{error}</FieldError>
      {fields.map(field => {
        const common = {
          description: field.description,
          isDisabled: field.isDisabled,
          label: field.label,
          value: field.value,
        };

        const additional = (({ cta, icon, price }: RadioButtonData) => {
          if (cta) {
            return { cta };
          }
          if (icon) {
            return { icon };
          }
          return { price };
        })(field);

        return (
          <RadioButton
            key={field.value}
            isDiscrete={hasDiscreteFields}
            {...common}
            {...additional}
          />
        );
      })}
    </Styled.Fieldset>
  ) : null;
